import { Skeleton } from "@/components/ui/skeleton";
import { SiteHeader } from "@/components/site-header";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export function PlatformMembersLoading() {
  return (
    <div className="flex flex-col h-full">
      <SiteHeader
        title="Team Management"
        subtitle="Manage team members with role-based access control"
      >
        {/* Search */}
        <Skeleton className="h-9 w-[250px] lg:w-[300px]" />
        {/* Role Filter */}
        <Skeleton className="h-9 w-[180px]" />
        {/* Status Filter */}
        <Skeleton className="h-9 w-[180px]" />
        {/* Add Members Button */}
        <Skeleton className="h-9 w-[140px]" />
      </SiteHeader>

      <div className="flex-1 overflow-auto">
        <div className="px-4 py-6 md:px-8 md:py-8">
          {/* Table Skeleton */}
          <div className="rounded-md border shadow-sm">
            <Table>
          <TableHeader>
            <TableRow className="bg-muted/50">
              <TableHead>User</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Permissions</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="w-[50px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: 5 }).map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-10 w-10 rounded-full" />
                    <div className="flex flex-col gap-1.5">
                      <Skeleton className="h-4 w-[150px]" />
                      <Skeleton className="h-3 w-[180px]" />
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <Skeleton className="h-6 w-[120px] rounded-full" />
                </TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1.5">
                    <Skeleton className="h-5 w-[80px] rounded-full" />
                    <Skeleton className="h-5 w-[90px] rounded-full" />
                    <Skeleton className="h-5 w-[100px] rounded-full" />
                    <Skeleton className="h-5 w-[85px] rounded-full" />
                    <Skeleton className="h-5 w-[95px] rounded-full" />
                  </div>
                </TableCell>
                <TableCell>
                  <Skeleton className="h-6 w-[80px] rounded-full" />
                </TableCell>
                <TableCell>
                  <Skeleton className="h-8 w-8 rounded-md" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
        </div>
      </div>
    </div>
  );
}
